/* global axios */

const knowledgeProxy = (accountId, path) =>
  `/api/v1/accounts/${accountId}/proxy/knowledge${path}`;

const state = {
  analytics: null,

  filters: {
    inbox_id: null,
    campaign: null,
    ads_name: null,
  },

  dateRange: {
    start_date: null,
    end_date: null,
  },

  isLoading: false,
  isError: false,
};

const getters = {
  getAnalytics: state => state.analytics,
  getFilters: state => state.filters,
  getDateRange: state => state.dateRange,
  isLoading: state => state.isLoading,
  isError: state => state.isError,
};

const mutations = {
  SET_ANALYTICS(state, payload) { state.analytics = payload; },
  SET_FILTERS(state, payload) { state.filters = { ...state.filters, ...payload }; },
  SET_DATE_RANGE(state, payload) { state.dateRange = { ...state.dateRange, ...payload }; },
  SET_IS_LOADING(state, isLoading) { state.isLoading = isLoading; },
  SET_IS_ERROR(state, isError) { state.isError = isError; },
};

const actions = {
  async fetchAdsAnalytics({ rootGetters, commit }, params = {}) {
    const accountId = rootGetters.getCurrentAccountId;
    commit('SET_IS_LOADING', true);
    commit('SET_IS_ERROR', false);

    try {
      const res = await axios.get(
        knowledgeProxy(accountId, `/chatbot/accounts/${accountId}/ads-analytics`),
        { params }
      );
      commit('SET_ANALYTICS', res.data);
      return res.data;
    } catch (error) {
      console.error('Fetch ads analytics failed:', error);
      commit('SET_IS_ERROR', true);
      throw error.response?.data || error;
    } finally {
      commit('SET_IS_LOADING', false);
    }
  },

  async updateFilterAndFetch({ state, commit, dispatch }, newFilters) {
    commit('SET_FILTERS', newFilters);
    const params = { ...state.filters, ...state.dateRange };
    return await dispatch('fetchAdsAnalytics', params);
  },

  async updateDateAndFetch({ state, commit, dispatch }, newDates) {
    commit('SET_DATE_RANGE', newDates);
    const params = { ...state.filters, ...state.dateRange };
    return await dispatch('fetchAdsAnalytics', params);
  },

  async clearFiltersAndFetch({ commit, dispatch }) {
    const defaultFilters = { inbox_id: null, campaign: null, ads_name: null };
    const defaultDateRange = { start_date: null, end_date: null };
    commit("SET_FILTERS", defaultFilters);
    commit("SET_DATE_RANGE", defaultDateRange);
    return dispatch("fetchAdsAnalytics", { ...defaultFilters, ...defaultDateRange });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
